import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './AllServices.css';

// Icônes - CORRECTION : FaFrance supprimé, remplacé par FaFlag
import {
    FaGlobe,
    FaFlag,
    FaUniversity,
    FaSchool,
    FaGraduationCap,
    FaChalkboardTeacher,
    FaFileAlt,
    FaCheckCircle,
    FaArrowRight,
    FaInfoCircle,
    FaHeadset,
    FaChartLine,
    FaUserGraduate,
    FaHandshake,
    FaCalendarAlt,
    FaLanguage,
    FaVisa,
    FaHome,
    FaBook,
    FaClipboardCheck
} from 'react-icons/fa';

const AllService = () => {
    // Liste des services
    const servicesItems = [
        { 
            text: "Étudiant étranger Hors France", 
            link: "/etudiant-etranger-hors-france",
            icon: FaGlobe,
            description: "Accompagnement complet pour les étudiants souhaitant venir étudier en France depuis l'étranger",
            features: [
                "Orientation scolaire personnalisée",
                "Aide à la constitution du dossier",
                "Préparation aux tests de langue",
                "Accompagnement visa",
                "Recherche de logement",
                "Suivi post-arrivée"
            ]
        },
        { 
            text: "Étudiant étranger déjà en France", 
            link: "/etudiant-etranger-en-france",
            icon: FaFlag, // CORRECTION : FaFrance remplacé par FaFlag
            description: "Solutions sur mesure pour les étudiants étrangers déjà présents sur le territoire français",
            features: [
                "Réorientation universitaire",
                "Changement de filière",
                "Passerelles et équivalences",
                "Aide à la poursuite d'études",
                "Accompagnement administratif",
                "Recherche de stage et alternance"
            ]
        },
        { 
            text: "École - Université africaine", 
            link: "/ecole-universite-africaine",
            icon: FaUniversity,
            description: "Partenariats et collaborations avec les établissements d'enseignement supérieur africains",
            features: [
                "Mise en place de partenariats",
                "Programmes d'échanges",
                "Double diplômes",
                "Mobilité enseignante",
                "Coopération académique",
                "Projets de recherche communs"
            ]
        },
        { 
            text: "École - Université française", 
            link: "/ecole-universite-francaise",
            icon: FaSchool,
            description: "Relations avec les établissements français pour le recrutement international",
            features: [
                "Recrutement d'étudiants internationaux",
                "Salons et événements",
                "Visibilité internationale",
                "Accords de coopération",
                "Programmes sur mesure",
                "Accompagnement personnalisé"
            ]
        }
    ];

    // Informations complémentaires
    const infoBlocks = [
        {
            icon: FaHeadset,
            title: "Accompagnement personnalisé",
            content: "Notre équipe d'experts vous guide à chaque étape de votre projet d'études en France."
        },
        {
            icon: FaChartLine,
            title: "Expertise reconnue",
            content: "Plus de 10 ans d'expérience dans l'accompagnement des étudiants et des établissements."
        },
        {
            icon: FaHandshake,
            title: "Réseau de partenaires",
            content: "Des partenariats solides avec des universités et grandes écoles en France et en Afrique."
        }
    ];

    return (
        <div className="allservice-section">
            <Header />
            
            <div className="allservice-container">
                {/* En-tête */}
                <div className="allservice-header">
                    <h1>
                        <FaGraduationCap className="header-icon" />
                        Nos Services
                    </h1>
                    <p className="allservice-subtitle">
                        Des solutions adaptées à chaque profil pour concrétiser votre projet d'études en France
                    </p>
                </div>

                {/* Grille des services */}
                <div className="services-grid">
                    {servicesItems.map((service, index) => {
                        const Icon = service.icon;
                        
                        return (
                            <Link 
                                to={service.link} 
                                className="service-card"
                                key={index}
                            >
                                <div className="service-header">
                                    <Icon className="service-icon" />
                                    <h2>{service.text}</h2>
                                </div>
                                
                                <div className="service-body">
                                    <p className="service-description">
                                        {service.description}
                                    </p>
                                    
                                    <ul className="service-features">
                                        {service.features.slice(0, 4).map((feature, idx) => (
                                            <li key={idx}>
                                                <FaCheckCircle className="feature-icon" />
                                                {feature}
                                            </li>
                                        ))}
                                    </ul>
                                    
                                    <div className="service-btn">
                                        En savoir plus
                                        <FaArrowRight />
                                    </div>
                                </div>
                            </Link>
                        );
                    })}
                </div>

                {/* Section d'information */}
                <div className="allservice-info">
                    <h3 className="info-title">
                        <FaInfoCircle />
                        Pourquoi choisir ETEF ?
                    </h3>
                    
                    <div className="info-content">
                        {infoBlocks.map((block, index) => {
                            const Icon = block.icon;
                            
                            return (
                                <div className="info-block" key={index}>
                                    <h4>
                                        <Icon />
                                        {block.title}
                                    </h4>
                                    <p>{block.content}</p>
                                    <ul>
                                        <li>
                                            <FaCheckCircle />
                                            Service personnalisé
                                        </li>
                                        <li>
                                            <FaCheckCircle />
                                            Réactivité garantie
                                        </li>
                                        <li>
                                            <FaCheckCircle />
                                            Satisfaction client
                                        </li>
                                    </ul>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Section CTA */}
                <div className="text-center mt-4">
                    <p style={{ color: '#4a5568', fontSize: '1.1rem', marginBottom: '20px' }}>
                        Vous avez des questions ? Notre équipe est là pour vous répondre.
                    </p>
                    <Link 
                        to="/contact" 
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '16px 32px',
                            background: 'linear-gradient(135deg, var(--secondary-red) 0%, var(--secondary-red-solid) 100%)',
                            color: 'white',
                            textDecoration: 'none',
                            borderRadius: '12px',
                            fontWeight: '600',
                            fontSize: '1.1rem',
                            transition: 'all 0.3s ease',
                            boxShadow: '0 10px 25px rgba(220, 20, 60, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'translateY(-3px)';
                            e.target.style.boxShadow = '0 15px 35px rgba(220, 20, 60, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 10px 25px rgba(220, 20, 60, 0.3)';
                        }}
                    >
                        Contactez-nous
                        <FaArrowRight />
                    </Link>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default AllService;